<template>
  <div>
    <botton-bar/>
    <div class="content">
      <div class="container profile-page">
        <div class="card profile-summary mb-3">
          <div class="card-body text-center">
            <div class="user">
              <i class="fa-solid fa-user"></i>
            </div>

            <div class="small text-muted mb-1" v-if="user.nome_membro">{{ user.nome_membro }}</div>
            <h5 class="font-weight-bold text-primary mb-2">
              {{ regional.nome_regional }} - {{ regional.sigla_estado }}
            </h5>
            <p class="text-muted mb-3">
              Gerencie sua conta, aparência e informações do app
            </p>

            <div class="profile-summary__actions">
              <button class="btn btn-outline-primary mr-sm-2 mb-1 mb-sm-0" @click="alterarRegional">Alterar regional</button>
              <button class="btn btn-primary px-4" v-if="user.id_membro" @click="sair()">Sair</button>
              <router-link to="/login" class="btn btn-primary px-4" v-else>Login</router-link>
            </div>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-body">
            <div class="profile-section-head">
              <h6 class="font-weight-bold mb-1">Sua conta</h6>
            </div>

            <router-link to="/perfil/dados" class="profile-item">
              <div class="profile-item__icon">
                <i class="fa-solid fa-user"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Editar perfil</div>
                <div class="profile-item__subtitle">Altere seus dados.</div>
              </div>
              <i class="fa-solid fa-chevron-right profile-item__arrow"></i>
            </router-link>

            <a href="javascript:" class="profile-item" @click="compartilhar()">
              <div class="profile-item__icon">
                <i class="fa-solid fa-share-nodes"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Compartilhar app</div>
                <div class="profile-item__subtitle">Envie o CRS para outras pessoas.</div>
              </div>
              <i class="fa-solid fa-chevron-right profile-item__arrow"></i>
            </a>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-body">
            <div class="profile-section-head">
              <h6 class="font-weight-bold mb-1">Aparência</h6>
            </div>

            <button class="profile-item profile-item--button" :class="{ active: !theme }" @click="alterarTema()">
              <div class="profile-item__icon">
                <i class="fa-solid fa-desktop"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Usar do sistema</div>
                <div class="profile-item__subtitle">Segue a preferência do aparelho.</div>
              </div>
              <i :class="!theme ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle profile-item__arrow'"></i>
            </button>

            <button class="profile-item profile-item--button" :class="{ active: theme === 1 }" @click="alterarTema(1)">
              <div class="profile-item__icon">
                <i class="fa-solid fa-moon"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Modo escuro</div>
                <div class="profile-item__subtitle">Mais confortável em baixa luz.</div>
              </div>
              <i :class="theme === 1 ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle profile-item__arrow'"></i>
            </button>

            <button class="profile-item profile-item--button" :class="{ active: theme === 2 }" @click="alterarTema(2)">
              <div class="profile-item__icon">
                <i class="fa-solid fa-sun"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Modo claro</div>
                <div class="profile-item__subtitle">Visual limpo e com mais contraste.</div>
              </div>
              <i :class="theme === 2 ? 'fa-solid fa-circle-check text-primary' : 'fa-regular fa-circle profile-item__arrow'"></i>
            </button>
          </div>
        </div>

        <div class="card mb-3">
          <div class="card-body">
            <div class="profile-section-head">
              <div class="small text-muted text-uppercase font-weight-bold">Aplicativo</div>
            </div>

            <router-link to="/regional" class="profile-item">
              <div class="profile-item__icon">
                <i class="fa-solid fa-circle-info"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Sobre o CRS</div>
                <div class="profile-item__subtitle">Saiba mais sobre o projeto.</div>
              </div>
              <i class="fa-solid fa-chevron-right profile-item__arrow"></i>
            </router-link>

            <router-link to="/privacidade" class="profile-item">
              <div class="profile-item__icon">
                <i class="fa-solid fa-shield-halved"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Politica de privacidade</div>
                <div class="profile-item__subtitle">Veja como seus dados são tratados..</div>
              </div>
              <i class="fa-solid fa-chevron-right profile-item__arrow"></i>
            </router-link>

            <router-link to="/termos-uso" class="profile-item">
              <div class="profile-item__icon">
                <i class="fa-solid fa-file-lines"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Termos de uso</div>
                <div class="profile-item__subtitle">Entenda as regras de uso do app.</div>
              </div>
              <i class="fa-solid fa-chevron-right profile-item__arrow"></i>
            </router-link>

            <a href="javascript:" class="profile-item profile-item--danger" @click="logout">
              <div class="profile-item__icon profile-item__icon--danger">
                <i class="fa-solid fa-trash"></i>
              </div>
              <div class="profile-item__content">
                <div class="profile-item__title">Apagar dados</div>
                <div class="profile-item__subtitle">Limpa os dados locais.</div>
              </div>
              <i class="fa-solid fa-chevron-right profile-item__arrow"></i>
            </a>
          </div>
        </div>

        <div class="text-center small text-muted pb-2">Versao: {{ version }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BottonBar from "@/components/BottonBar";

export default {
  name: 'Perfil',
  components: { BottonBar },
  data() {
    return {
      token: localStorage.getItem('token')
    }
  },

  methods: {
    alterarRegional() {
      localStorage.removeItem('setor');
      this.$store.commit('setRegionalId', null);
      this.$router.push('/');
    },

    logout() {
      this.$swal({
        text: "Deseja realmente apagar os dados do seu aplicativo?",
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.$store.commit('logout');
          this.$router.push('/');
        }
      }));
    },

    sair() {
      this.$swal({
        text: "Deseja realmente sair?",
        buttons: ["Cancelar", "Sim!"],
        dangerMode: true
      }).then((res => {
        if (res) {
          const regionalId = this.$store.state.id_regional;
          this.$store.commit('logout');
          window.location.href = `/calendario?regional=${regionalId || ''}`
        }
      }));
    },

    compartilhar() {
      try {
        navigator.share({
          title: `CRS - Calendario CCB`,
          text: `Clique no link para baixar o CRS - Calendario CCB`,
          url: 'https://calendarioccb.com.br/app',
        });
      } catch (err) {
        this.$swal('Dispositivo incompativel com o compartilhamento.');
      }
    },

    alterarTema(tema) {
      this.$store.commit('setTheme', tema);
      if (tema === 1 || tema === 2) {
        localStorage.setItem('theme', tema);
      } else {
        localStorage.removeItem('theme');
      }

      window.dispatchEvent(new Event('theme-preference-updated'));
    }
  },

  computed: {
    user() {
      return this.$store.state.user
    },

    regional() {
      return this.$store.state.dados.regional;
    },

    theme() {
      return this.$store.state.theme;
    },

    resolvedTheme() {
      return this.$store.state.resolvedTheme;
    }
  },

  mounted() {
    document.body.classList.remove("modal-open");
  }
}
</script>

<style scoped>
.profile-page {
  max-width: 600px;
}

.profile-summary {
  border-radius: 22px;
}

.profile-summary__actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.user {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 1.5rem;
  background-color: var(--bg-theme);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  border: 2px solid var(--primary);
}

.profile-section-head {
  margin-bottom: 6px;
}

.profile-item {
  display: flex;
  align-items: center;
  color: var(--text-theme);
  text-decoration: none;
  padding: 14px 0;
  border-bottom: 1px solid var(--border-color);
  transition: color 0.16s ease;
}

.profile-item:last-child {
  border-bottom: none;
  padding-bottom: 6px;
}

.profile-item:hover {
  color: var(--text-theme);
  text-decoration: none;
}

.profile-item--button {
  width: 100%;
  background: transparent;
  border-left: none;
  border-right: none;
  border-top: none;
  text-align: left;
}

.profile-item--button.active .profile-item__title {
  color: var(--primary);
}

.profile-item__icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-theme);
  color: var(--primary);
  flex: 0 0 42px;
  margin-right: 12px;
}

.profile-item__icon--danger {
  background: rgba(194, 61, 61, 0.08);
  color: #c23d3d;
}

.profile-item__content {
  flex: 1 1 auto;
  min-width: 0;
}

.profile-item__title {
  font-weight: 700;
  line-height: 1.2;
}

.profile-item__subtitle {
  font-size: 0.82rem;
  color: var(--text-theme-secondary);
  line-height: 1.25;
  margin-top: 2px;
}

.profile-item__arrow {
  color: var(--text-theme-secondary);
  margin-left: 12px;
  flex: 0 0 auto;
}

.profile-item--danger .profile-item__title {
  color: #c23d3d;
}

@media (max-width: 576px) {
  .profile-summary__actions .btn {
    width: 100%;
  }

  .profile-summary__actions .btn + .btn,
  .profile-summary__actions .btn + a.btn {
    margin-top: 10px;
  }
}
</style>
